import { useQuery, useQueryClient } from "@tanstack/vue-query";
import { watch, Ref } from "vue";
import { FinOneCategoriaProductoAction } from "../../actions/categoriaActions";

export function useCategoriaProductoFindOne(id: Ref<string>) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ["CategoriaProductoFindOne", id],
    queryFn: () => FinOneCategoriaProductoAction(id.value),
    enabled: !!id.value, // evita ejecutar si id está vacío
    staleTime: 60 * 1000,
  });

  // Si cambia el ID, hacer prefetch
  watch(id, (newId) => {
    if (newId) {
      queryClient.prefetchQuery({
        queryKey: ["CategoriaProductoFindOne", newId],
        queryFn: () => FinOneCategoriaProductoAction(newId),
      });
    }
  });

  return {
    ...query,
  };
}
